<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-style-1 shape-wine shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3"><img src="img/brand/hinagiku-logo-notext.png" style="width: 60px;" class="img-fluid">
                &nbsp;<img src="img/brand/white.png" style="width: 200px;" class="img-fluid">
              </h1>
              <p class="lead text-white">このサークルは、小鳥遊 昴が運営する二次創作中心小説同人サークルです。現在は主に合成音声
                キャラクター系二次創作を取り扱っています。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 mt--300">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="ni ni-books" type="primary" rounded class="mb-4">
                  </icon>
                  <h6 class="text-primary text-uppercase">個人誌（二次創作小説）</h6>
                  <p class="description mt-3">今まで雛菊書房で発行した、二次創作小説同人誌のリストはこちら。</p>
                  <router-link to="/books">
                    <base-button type="primary" class="mt-4">
                      個人誌一覧
                    </base-button>
                  </router-link>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-users" type="success" rounded class="mb-4">
                  </icon>
                  <h6 class="text-success text-uppercase">合同誌・アンソロジー</h6>
                  <p class="description mt-3">今まで雛菊書房で企画・主催した合同誌及びアンソロジーのリストはこちら。</p>
                  <router-link to="/anthologies">
                    <base-button type="success" class="mt-4">
                      合同誌一覧
                    </base-button>
                  </router-link>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="ni ni-calendar-grid-58" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">即売会参加情報</h6>
                  <p class="description mt-3">直近の参加即売会情報、過去に参加した/今後参加予定の即売会のリストはこちら。</p>
                  <router-link to="/events">
                    <base-button type="warning" class="mt-4">
                      即売会情報
                    </base-button>
                  </router-link>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3"><img src="img/brand/hinagiku-logo-notext.png" style="width: 50px;" class="img-fluid">　雛 菊 書 房 に つ い て</h2>
            <p class="lead">雛菊書房は、小鳥遊 昴が運営する小説同人サークルです。
            <br>2019年3月から活動しています。</p>
            <div class="btn-wrapper">
              <base-button tag="a"
                           href="https://twitter.com/HinagikuBooks"
                           class="mb-3 mb-sm-0"
                           type="info"
                           icon="fa fa-twitter">
                Twitter
              </base-button>
              <base-button tag="a"
                           href="https://www.pixiv.net/users/7740759"
                           class="mb-3 mb-sm-0"
                           type="primary"
                           icon="fa fa-link">
                Pixiv
              </base-button>
            </div>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-4">
            <icon name="ni ni-book-bookmark" size="lg" gradient="white" shadow round color="primary"></icon>
            <h5 class="mt-3">主な活動ジャンル</h5>
            <p class="mt-3">現在は主に合成音声キャラクター（VOCALOID/VOICEROID/CeVIO/A.I.VOICE/AITalk系/その他)ジャンルを中心に、
              広義の百合小説を書いています。</p>
          </div>
          <div class="col-lg-4">
            <icon name="ni ni-favourite-28" size="lg" gradient="white" shadow round color="primary"></icon>
            <h5 class="mt-3">作品傾向</h5>
            <p class="mt-3">関係性大好きオタク、CP厨。結月ゆかりが関わる関係性が主に好きなほか、紲星あかりと琴葉茜（あかあか）など、
              執筆範囲は様々です。</p>
          </div>
          <div class="col-lg-4">
            <icon name="ni ni-bullet-list-67" size="lg" gradient="white" shadow round color="primary"></icon>
            <h5 class="mt-3">その他活動ジャンル</h5>
            <p class="mt-3">過去（2013年～2018年）には「小鳥遊 昴」名義でギャルゲージャンルでオーガストオンリー小説アンソロサークルに寄稿していました。</p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-0">
      <div class="container">
        <card gradient="default"
              no-body
              shadow-size="lg"
              class="border-0">
          <div class="p-5">
            <div class="row align-items-center">
              <div class="col-lg-8">
                <h3 class="text-white">直近の即売会参加予定/実施企画</h3>
                <div v-for="item in recentEvents" :key="item.id">
                  <p class="lead text-white mt-3">{{ item.attributes.StartDate }} {{ item.attributes.Name }} （{{ item.attributes.Place }}）</p>
                </div>
              </div>
              <div class="col-lg-3 ml-lg-auto">
                <router-link to="/events">
                  <base-button type="white" block size="lg">
                    詳細はこちら
                  </base-button>
                </router-link>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>
<script>
import 'moment/locale/ja'
import moment from "moment";

export default {
  name: "top",
  components: {
    moment
  },
  data(){
    return {
      recentEvents: [],
    };
  },
  head: {
    meta: function () {
      return [
        { property: 'og:title', content: '雛菊書房 - Home' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: '小説二次創作中心同人小説サークル「雛菊書房」公式サイト' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary' },
      ]
    }
  },
  mounted() {
    moment.locale('ja')
    this.axios.get('/strapi/api/event-informations?sort[0]=StartDate%3Aasc&pagination[limit]=3&fields[0]=Name&fields[1]=StartDate&fields[2]=Place&filters[StartDate][$gte]=' + moment().format('YYYY-MM-DD'))
        .then(response => {
          this.recentEvents = response.data.data
          this.recentEvents.forEach(function (value, index, array){
            array[index]['attributes']['StartDate'] = moment(value['attributes']['StartDate']).format('YYYY/MM/DD(ddd)')
          })
        }).catch(error =>{
      console.log(error)
    })
  }
};
</script>
<style>
</style>
